import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const LegalNotice: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Mentions légales
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Les présentes mentions légales s’appliquent au site de vente en ligne de vêtements Bratan
        Family (ci-après le « Site »).
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          1. Éditeur du site
        </Typography>
        <Typography variant="body1" paragraph>
          Le Site est édité par <strong>Bratan Family</strong>, [forme juridique ou statut :
          entreprise individuelle, société, etc.], immatriculé(e) sous le numéro [SIREN / SIRET].
        </Typography>
        <Typography variant="body1" paragraph>
          Responsable de la publication : [Nom et prénom du responsable de la publication].
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          2. Contact
        </Typography>
        <Typography variant="body1" paragraph>
          Pour toute question ou demande d’information concernant le Site ou son contenu, vous
          pouvez contacter Bratan Family :
        </Typography>
        <Typography variant="body1" paragraph>
          • Par e-mail : bratanfamily59@gmail.com
          <br />
          • Par téléphone : +32 456 96 20 71
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          3. Hébergeur du site
        </Typography>
        <Typography variant="body1" paragraph>
          Le Site est hébergé par : [Nom de l’hébergeur], [forme juridique], dont le siège social
          est situé à [adresse complète], joignable au [numéro de téléphone] ou via [adresse e-mail
          de contact].
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          4. Propriété intellectuelle
        </Typography>
        <Typography variant="body1" paragraph>
          L’ensemble des éléments présents sur le Site (textes, visuels, photographies, logos,
          chartes graphiques, icônes, vidéos, sons, codes informatiques, etc.) est la propriété de
          Bratan Family ou fait l’objet d’une autorisation d’utilisation. Toute reproduction,
          représentation, modification, distribution ou exploitation, totale ou partielle, du Site
          ou de l’un de ses éléments, par quelque procédé que ce soit, sans l’autorisation écrite
          préalable de Bratan Family, est strictement interdite et susceptible de constituer une
          contrefaçon au sens du Code de la propriété intellectuelle.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          5. Données personnelles
        </Typography>
        <Typography variant="body1" paragraph>
          Bratan Family met en œuvre des traitements de données à caractère personnel dans le
          cadre de l’exploitation du Site (création et gestion de compte client, gestion des
          commandes, suivi des livraisons, gestion du panier et des favoris, envoi éventuel
          d’informations commerciales, etc.).
        </Typography>
        <Typography variant="body1" paragraph>
          Les modalités complètes de traitement de vos données (nature des données collectées,
          finalités, durées de conservation, droits des personnes, etc.) sont détaillées dans la
          <strong>Politique de confidentialité</strong> accessible sur le Site.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          6. Cookies
        </Typography>
        <Typography variant="body1" paragraph>
          Le Site utilise des cookies et autres traceurs nécessaires à son bon fonctionnement
          (authentification, panier, favoris, mesure d’audience, etc.). Vous pouvez configurer vos
          préférences en matière de cookies via les paramètres de votre navigateur. Pour plus
          d’informations, consultez la Politique de confidentialité.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          7. Responsabilité
        </Typography>
        <Typography variant="body1" paragraph>
          Bratan Family s’efforce d’assurer l’exactitude et la mise à jour des informations
          diffusées sur le Site. Toutefois, aucune garantie n’est apportée quant à l’exactitude,
          la complétude ou l’actualité des informations mises à disposition. Bratan Family ne
          saurait être tenue responsable des dommages directs ou indirects résultant de
          l’utilisation du Site ou de l’impossibilité d’y accéder.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          8. Liens hypertextes
        </Typography>
        <Typography variant="body1" paragraph>
          Le Site peut contenir des liens vers d’autres sites ou sources externes. Bratan Family ne
          peut être tenue responsable de la disponibilité de ces sites et sources externes ni des
          contenus, publicités, produits, services ou tout autre élément disponible sur ou à partir
          de ces sites ou sources.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          9. Droit applicable
        </Typography>
        <Typography variant="body1" paragraph>
          Les présentes mentions légales sont régies par le droit français. En cas de litige et à
          défaut de résolution amiable, les tribunaux français compétents seront seuls
          compétents.
        </Typography>
      </Box>
    </Container>
  );
};

export default LegalNotice;
